module.exports = __webpack_public_path__ + "img/traffic-light-orange.90f88d42.svg";